/* eslint-disable @nx/enforce-module-boundaries */
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ArrowDown, CloseIcon } from '@mybridge/icons';
import { Box, Button, Checkbox, CheckboxGroup, HStack, Radio, RadioGroup, Stack, Text } from '@mybridge/ui';
import { forwardRef, useMemo, useState, useEffect, useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CustomRadioButton } from 'v4/components/custom-radio-checkbx';
import { FilterPopover } from 'v4/components/filter-popover';
import { useRadioGroup } from '@chakra-ui/react';
import { SearchContext } from '../../../snippets/search/context';
import _ from 'lodash';
import styles from '../../filter-popover/filter-popover.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useSelector } from 'react-redux';
export const SearchFilterJobPremise = forwardRef(
  (
    {
      name = 'remote',
      title = 'On-site/Remote',
      titleKey = 'searchPage.onSiteRemote',
      onChange,
      value,
      defaultValue,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslator();
    const currentLanguage = useSelector((state) => state?.translation?.language) || 'en';
    const [selectedValue, setSelectedValue] = useState();
    const [popperOpen, setPopperOpen] = useState(false);
    const { resetFilters, setResetFilters } = useContext(SearchContext);
    const values = useMemo(
      () => [
        {
          title: t('searchPage.onSite') || 'On-site',
          value: '1',
        },
        {
          title: t('searchPage.remote') || 'Remote',
          value: '2',
        },
        {
          title: t('searchPage.hybrid') || 'Hybrid',
          value: '3',
        },
      ],
      [t, currentLanguage]
    );

    const { handleSubmit, control } = useForm();

    useEffect(() => {
      selectedValue ? setResetFilters(true) : setResetFilters(false)
    }, [selectedValue]);

    useEffect(() => {
      if(!resetFilters){
        setSelectedValue();
        // setSearch();
      }
    }, [resetFilters]);

    const onSubmit = (form) => {
      const data_ = _.find(values, function(o){return o.value == form});
      onChange?.({[name]:form});
      setSelectedValue(data_?.title);
      setPopperOpen(false);
    };

    const { getRadioProps, getRootProps } = useRadioGroup({
      onChange: onSubmit,
    })

    return (
      <>
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
          <FilterPopover
            trigger={
              <Button
                variant="transparent"
                fontSize="14px"
                color="brandGray.750"
                justifyContent="space-between"
                w="100%"
                px={1}
              >
                <HStack w="100%" justifyContent="space-between" spacing={1} overflow="hidden">
                  <Text noOfLines={1} textAlign="left" flex={1} title={selectedValue && resetFilters ? selectedValue : (t(titleKey) || title)}>
                    {selectedValue && resetFilters ? selectedValue : (t(titleKey) || title)}
                  </Text>
                  <Box flexShrink={0}>
                    {selectedValue && resetFilters ? (
                      <CloseIcon width="15" height="15" color="#3D5A80" cursor="pointer" onClick={(e) => { e.stopPropagation(); onSubmit(null); }} />
                    ) : (
                      <ArrowDown />
                    )}
                  </Box>
                </HStack>
              </Button>
            }
            onPopClose={(e) => setPopperOpen(e)}
          >
            <Controller
              render={({ field }) => (
                <RadioGroup {...field}>
                  <Stack className={styles.filterList}>
                    {values?.map?.((v, vIndex) => (
                      // <Radio key={vIndex} value={v?.value}>
                      //   {v?.title}
                      // </Radio>
                      <CustomRadioButton key={vIndex} justifyContent="flex-start" {...getRadioProps({ value: v?.value })}>{v?.title}</CustomRadioButton>
                    ))}
                  </Stack>
                </RadioGroup>
              )}
              control={control}
              name={name}
            />
          </FilterPopover>
        {/* </form> */}
      </>
    );
  }
);
